import { ExecException } from 'child_process';

const SETUP_DASHBOARD_FILE = '/usr/local/reyrey/storm_zero/storm-zero-0.0.8.AppImage';

export const verifyPassword = (password: string) =>
    new Promise((resolve) => {
        window.exec('echo \'' + password + '\' | sudo -k -S echo "password accepted"', (error: ExecException | null, stdout: string) => {
            if (error) {
                resolve(false);

                return;
            }

            const result = stdout.replace(/\s+/g, '');

            if (result === 'passwordaccepted') {
                resolve(true);
            }
        });
    });

export const startSetup = () => {
    const proc = window.exec(SETUP_DASHBOARD_FILE);

    return proc;
};
